










































































import DatePicker from "@/components/pickers/date-picker.vue";
import TimePicker from "@/components/pickers/time-picker.vue";
import { useFloorStore } from "@/pinia/floor-store";
import { FloorplanMarker, useFloorplanStore } from "@/pinia/floorplan-store";
import { defineComponent, nextTick, ref } from "@vue/composition-api";
import { LMap, LImageOverlay, LMarker } from "vue2-leaflet";

export default defineComponent({
    name: "floorplanControls",
    components: {
        TimePicker,
        DatePicker,
        LMap,
        LImageOverlay,
        LMarker,
    },
    setup(props, ctx) {
        const floorplanStore = useFloorplanStore();
        const floorStore = useFloorStore();

        const selectedUnplacedMarker = ref<FloorplanMarker | null>(null);

        const placeMarker = async (marker: FloorplanMarker) => {
            nextTick(() => (selectedUnplacedMarker.value = null));
            await floorplanStore.placeMarker(marker);
        };

        const saveScale = async () => {
            await floorStore.patch(floorplanStore.floor.id, {
                markerScale: floorplanStore.floor.markerScale,
            });
        };

        return { floorplanStore, placeMarker, saveScale, selectedUnplacedMarker };
    },
});
